import { getPseudoElementProperty } from './selector';

export default () => ({
  breakpoint: getPseudoElementProperty('body', ':before', 'content'),
  orientation: getPseudoElementProperty('body', ':after', 'content'),
});
